import React from "react"
import classnames from "@utils/classnames"

import styles from './section.module.scss'

const Section = ({ title, children, className, ...props }) => (
  <div {...props} className={classnames(styles.section, className)}>
    <h3>{title}</h3>
    <div>{children}</div>
  </div>
)

export default Section
